// Tabs primitives — Radix Tabs with the dashboard styling.
import { forwardRef } from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cx } from '../lib/cx'

const Tabs = TabsPrimitive.Root

const TabsList = forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(function TabsList({ className, ...props }, ref) {
  return (
    <TabsPrimitive.List
      ref={ref}
      className={cx(
        'flex w-full items-center gap-1 overflow-x-auto rounded-lg border border-panel-border bg-panel-muted p-1',
        className,
      )}
      {...props}
    />
  )
})

const TabsTrigger = forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(function TabsTrigger({ className, ...props }, ref) {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cx(
        'inline-flex min-w-[5.5rem] flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium text-ink-muted transition-colors',
        'hover:text-ink hover:bg-panel-raised',
        'data-[state=active]:bg-panel-raised data-[state=active]:text-ink data-[state=active]:shadow-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-info/60',
        className,
      )}
      {...props}
    />
  )
})

const TabsContent = forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(function TabsContent({ className, ...props }, ref) {
  return (
    <TabsPrimitive.Content
      ref={ref}
      className={cx(
        'mt-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-info/60 rounded-lg',
        className,
      )}
      {...props}
    />
  )
})

export { Tabs, TabsList, TabsTrigger, TabsContent }
